import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
const propTypes = {
  layout: PropTypes.oneOf(['half-and-half', 'full-width-image', 'two-images', 'side-by-side']),
  textHorizontalAlign: PropTypes.oneOf(['left', 'center', 'right']),
  textVerticalAlign: PropTypes.oneOf(['center', 'top', 'bottom'])
};
const StandardBanner = createComponent({
  displayName: 'StandardBanner',
  root: 'div',
  propTypes,
  propConfig: {
    classNames(props) {
      const {
        layout,
        textVerticalAlign = layout === 'side-by-side' ? 'bottom' : 'center',
        textHorizontalAlign
      } = props;
      const classNameSet = new Set(['swan-standard-banner']);
      if (layout && layout !== 'half-and-half') classNameSet.add("swan-standard-banner-layout-".concat(layout));
      if (textVerticalAlign) classNameSet.add("swan-standard-banner-text-vertical-align-".concat(textVerticalAlign));
      if (textHorizontalAlign) classNameSet.add("swan-standard-banner-text-align-".concat(textHorizontalAlign));
      return classNameSet;
    }
  }
});
StandardBanner.defaultProps = {
  layout: 'half-and-half',
  textHorizontalAlign: 'left'
};
export { StandardBanner };